module.exports = __webpack_public_path__ + "static/media/attachement.d76d7239.svg";